import { useAuthStore } from 'cloak-auth/src/Client/stores';
import { ReactNode } from 'react';

export default function NextWrapper({ children }: { readonly children: ReactNode }) {
    const hasNext = useAuthStore((state) => state.hasNext);

    return hasNext ? children : null;
}
